<div class="kpi" [class]="variant()">
  <div class="kpi-label">{{ label() }}</div>
  <div class="kpi-val">{{ value() }}</div>
  @if (footer()) {
    <div class="kpi-foot">{{ footer() }}</div>
  }
</div>
